import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './api/apollo'
import { createToast } from './ui/toast'

const app = createApp(App)
app.use(router)
app.provide('toast', createToast())
app.mount('#app')
